import { render, staticRenderFns } from "./wig-page-additional-properties-by-date-item.vue?vue&type=template&id=ecdbeffa"
import script from "./wig-page-additional-properties-by-date-item.vue?vue&type=script&lang=js"
export * from "./wig-page-additional-properties-by-date-item.vue?vue&type=script&lang=js"
import style0 from "./wig-page-additional-properties-by-date-item.vue?vue&type=style&index=0&id=ecdbeffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports